import { call, put, select, takeEvery } from '@redux-saga/core/effects';
import {
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
  SOFORTSCHUTZ_AVAILABLE_REQUEST,
} from '@ps20-frontend/shop-integration-redux';
import {
  SofortschutzAvailableRequest,
  SofortschutzAvailableResponse,
  SofortschutzVertrag,
} from '@ps20/bff-models';
import { App, convertToBffLaufzeit, getSpartenTypeByApp } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { DashboardActions } from '../dashboard.actions';
import { angebotIsTarifiert } from '../selectors/warenkorb.selector';

export function* watchSofortschutzRelevantEvents() {
  yield takeEvery(
    GlobalActions.UPDATE_SOFORTSCHUTZ_AVAILABLE,
    safeSaga(callSofortschutzAvailable, App.SHOP_DASHBOARD),
  );

  yield takeEvery(
    SOFORTSCHUTZ_AVAILABLE_REQUEST.SOFORTSCHUTZ_AVAILABLE_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_DASHBOARD),
  );
}

const globalActions = new GlobalActions();

export function* callSofortschutzAvailable() {
  const url = '/privatschutz/api/sofortschutzAvailable';
  const state: IAppState = yield select();

  const sofortschutzAvailableRequest: SofortschutzAvailableRequest = {
    sofortschutzVertraege: buildSofortschutzVertraege(state),
  };

  const globalPut = GlobalPut.getInstance();
  yield call(
    globalPut.put.bind(globalPut),
    globalActions.doRequest({
      appId: App.SHOP_DASHBOARD,
      body: sofortschutzAvailableRequest,
      url,
      successEvent: SOFORTSCHUTZ_AVAILABLE_REQUEST.SOFORTSCHUTZ_AVAILABLE_REQUEST_SUCCESSFUL,
      errorEvent: SOFORTSCHUTZ_AVAILABLE_REQUEST.SOFORTSCHUTZ_AVAILABLE_REQUEST_FAILED,
    }),
  );
}

function buildSofortschutzVertraege(state: IAppState): Array<SofortschutzVertrag> {
  const sofortschutzVertraege: Array<SofortschutzVertrag> = [];
  state.warenkorb
    .filter(value => !value.beibehalten)
    .filter(value => value.appId !== App.JHP)
    .filter(value => value.appId !== App.GEGE)
    .filter(value => value.laufzeit === 3)
    .forEach(produkt => {
      if (angebotIsTarifiert(produkt)) {
        sofortschutzVertraege.push({
          laufzeit: convertToBffLaufzeit(produkt.laufzeit),
          produktlinie: produkt.ausgewaehlteLinie,
          spartenType: getSpartenTypeByApp(produkt.appId),
          angebotsId: produkt.angebotsId,
        });
      }
    });
  return sofortschutzVertraege;
}

export function* successCallback(action: DoRequestResponse<SofortschutzAvailableResponse>) {
  yield put(new DashboardActions().showSofortschutzHinweistext(action.payload.displayHinweistext));
  const globalPut = GlobalPut.getInstance();
  yield call(
    [globalPut, globalPut.put],
    globalActions.sofortschutzAvailable(action.payload.sofortschutzAvailable),
  );
}
